export default "/assets/certification_footer_no_background-cf10c08d52b87067d1dba4f6d63719fba87d9fed36ae12fd55f0fa00c8400103.png";